import { Grid, Text } from "@mantine/core";
import { useUser } from "../../../../../hooks/react-query/useUser";
import { MyH1 } from "../../../../UI/my-h1/MyH1";
import { useScheduleList } from "../../../../../hooks/react-query/useSchedules";
import { Schedule } from "../../../../../constants/model/models";
import { StepperButtons } from "./StepperButtons";
import { bookingStore } from "../../../../config/store/bookingStore";
import { useColors } from "../../../../../hooks/colors/useColors";
import { IconBuilding, IconVideo } from "@tabler/icons";
import { showLocalizedDateTime } from "../../../../../services/dateAndTime/dateAndTimeUtil";
import { useEffect, useState } from "react";
import { useAppointment } from "../useAppointment";
import { useTranslation } from "next-i18next";
import { isMobile } from "react-device-detect";
import PaymentOptions from "../payments/PaymentOptions";
import { AnonymousSignInSignUp } from "./AnonymousSignInSignUp";

export function FourthStep() {
  const { user } = useUser();
  const { schedules } = useScheduleList();
  const { stepperFields, bookingForm, setPrepaymentStep, amount } =
    bookingStore((state) => state);
  const { calculateAmountToPay, submitBooking } = useAppointment();
  const { colors } = useColors();
  const [processing, setProcessing] = useState<boolean>(false);
  const { t, i18n } = useTranslation("common");

  useEffect(() => {
    calculateAmountToPay();
  }, [bookingForm]);

  function showSpecialistName() {
    if (schedules && schedules.length > 0) {
      const schedule: Schedule | undefined = schedules.find(
        (schedule) => schedule.id === stepperFields.specialist?.id
      );
      if (schedule) {
        return schedule.name;
      } else {
        return "";
      }
    } else {
      return "";
    }
  }

  async function finish() {
    console.log(user, amount)
    if (user) {
      if (amount > 0) {
        setPrepaymentStep(true);
      } else if (bookingForm) {
        await submitBooking(bookingForm, setProcessing);
      }
    }
  }

  async function finalizeRegistration() {
    setProcessing(true);
    setTimeout(async () => {
      await finish();
      setProcessing(false);
    }, 1000);
  }

  console.log(stepperFields, bookingForm)

  return (
    <div>
      {bookingForm && (
        <Grid className="mb-6">
          <Grid.Col span={12} className="my-6">
            <MyH1 centerText size={isMobile ? "2.2rem" : "3rem"}>
              {t("booking.details")}
            </MyH1>
            {/*<Text*/}
            {/*  color={colors.grayText}*/}
            {/*  className="text-center font-bold mt-4"*/}
            {/*>*/}
            {/*  {t("booking.onlineDisclaimer")}*/}
            {/*</Text>*/}
          </Grid.Col>
          <Grid.Col
            span={{ base: 12, md: 6, lg: 4 }}
            className="flex flex-col justify-center items-center"
          >
            <MyH1 size={isMobile ? "2rem" : "2.5rem"}>
              {t("appointments.format")}
            </MyH1>
            {stepperFields.format === "onPremise" &&
               (
                <div className="flex flex-col relative justify-center items-center">
                  <Text
                    className="!text-3xl absolute top-0 text-center font-bold"
                    color={colors.grayText}
                  >
                    {t("appointments.onPremise")}
                  </Text>
                  <IconBuilding
                    color={colors.grayText}
                    size="14rem"
                    stroke={1}
                    className="mt-4"
                  />
                </div>
              )}
            {stepperFields.format === "online"  && (
              <div className="flex flex-col relative justify-center items-center">
                <Text
                  className="!text-3xl absolute top-2 text-center font-bold"
                  color={colors.grayText}
                >
                  {t("appointments.online")}
                </Text>
                <IconVideo color={colors.grayText} size="14rem" stroke={0.5} />
              </div>
            )}
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
            <div className="flex justify-center">
              <div className="flex flex-col justify-center gap-16">
                <div>
                  <MyH1 size={isMobile ? "2rem" : "2.5rem"} centerText>
                    {t("appointments.dateTime")}
                  </MyH1>
                  <Text
                    className="!text-3xl text-center font-bold"
                    color={colors.grayText}
                  >
                    {showLocalizedDateTime(
                      bookingForm.slotStart,
                      i18n.language,
                      "ll, LT"
                    )}
                  </Text>
                </div>
                <div>
                  <MyH1 size={isMobile ? "2rem" : "2.5rem"} centerText>
                    {t("appointments.specialty")}
                  </MyH1>
                  <Text
                    className="text-3xl text-center font-bold"
                    color={colors.grayText}
                  >
                    {stepperFields.specialty}
                  </Text>
                </div>
              </div>
            </div>
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 4 }} offset={{ md: 3, lg: 0 }}>
            <div className="flex flex-col justify-center items-center mt-4 lg:mt-0">
              <MyH1 size={isMobile ? "2rem" : "2.5rem"} centerText>
                {t("appointments.specialist")}
              </MyH1>
              <Text className="!text-3xl font-bold" color={colors.grayText}>
                {showSpecialistName()}
              </Text>
              {amount > 0 && (
                <div className="flex flex-col justify-center items-center mt-4 lg:mt-14 md:mt-14">
                  <MyH1 size={isMobile ? "2rem" : "2.5rem"} centerText>
                    {t("booking.price")}
                  </MyH1>
                  <Text className="text-3xl font-bold" color={colors.grayText}>
                    Є{amount}
                  </Text>
                </div>
              )}
            </div>
          </Grid.Col>
        </Grid>
      )}
      {user && user.user && (
        <PaymentOptions setProcessing={setProcessing} processing={processing} />
      )}
      {!user && <AnonymousSignInSignUp />}
      <StepperButtons finish={finish} processing={processing} />
    </div>
  );
}
